import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsFetching } from '@tanstack/react-query';

import { Button, TabsGroup } from '@unified-checkout/design-system';

import { RISK_CENTER_TAB_FILTERS } from '@app/dashboard/constants/risk_center';
import type {
  IRiskCenterTabProps,
  IRiskCenterTabsFilter,
} from '@app/dashboard/types/innerLayout/risk_center/header';

import AddEditModal from '../Modals/AddEditModal';

import styles from './Header.module.scss';

const Header = ({
  appliedRiskCenterTab,
  setAppliedRiskCenterTab,
}: {
  appliedRiskCenterTab: IRiskCenterTabProps;
  setAppliedRiskCenterTab: Dispatch<
    SetStateAction<IRiskCenterTabProps['name']>
  >;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const isFetching = useIsFetching();

  const handleTabClick = (tabName: IRiskCenterTabsFilter['name']) => {
    if (!tabName) return;
    setAppliedRiskCenterTab(tabName);
  };

  return (
    <div className={styles['header']}>
      <div className={styles['header__text-box']}>
        <div className={styles['header__text-box-content']}>
          <span className={styles['header__text-box-content-title']}>
            {t('innerLayout.riskCenter.title')}
          </span>
          <span className={styles['header__text-box-content-hint']}>
            {appliedRiskCenterTab.hintDescription}
          </span>
        </div>
        <Button
          text={appliedRiskCenterTab.btnLabel}
          onClickHandler={() => setIsModalOpen(true)}
          disabled={!!isFetching}
        />
      </div>
      <AddEditModal
        currentTab={appliedRiskCenterTab.name}
        isModalOpen={isModalOpen}
        setIsShareModalOpen={setIsModalOpen}
      />
      <div className={styles['header__tabs']}>
        <div className={styles['header__tabs-group-wrapper']}>
          <TabsGroup
            type="line"
            orientation="horizontal"
            tabsProps={RISK_CENTER_TAB_FILTERS(t).map(({ name, label }) => ({
              active: appliedRiskCenterTab.name === name,
              disabled: !!isFetching,
              tabName: name,
              tabLabel: label,
              onClickHandler: () => handleTabClick(name),
            }))}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
